import { render, staticRenderFns } from "./ContratoPF2.vue?vue&type=template&id=28f8e76c"
import script from "./ContratoPF2.vue?vue&type=script&lang=js"
export * from "./ContratoPF2.vue?vue&type=script&lang=js"
import style0 from "./ContratoPF2.vue?vue&type=style&index=0&id=28f8e76c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports